<template>
    <div class="pa-2" style="max-width: 100%;">
        <!-- Panel de KPIs Generales -->
        <v-row dense class="mb-4">
            <v-col cols="12" md="3" sm="6">
                <v-card class="dashboard-card premium-card gradient-success rounded-xl" elevation="4">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <div class="text-caption text-uppercase font-weight-bold white--text mb-1">Proveedores (100%
                                Doc)</div>
                            <h2 class="text-h4 font-weight-black white--text">{{ kpis.completeProviders }}</h2>
                        </div>
                        <v-icon size="48" color="rgba(255,255,255,0.3)">mdi-check-decagram</v-icon>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-card class="dashboard-card premium-card gradient-warning rounded-xl" elevation="4">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <div class="text-caption text-uppercase font-weight-bold white--text mb-1">Docs a Vencer (30
                                días)</div>
                            <h2 class="text-h4 font-weight-black white--text">{{ kpis.expiringDocs }}</h2>
                        </div>
                        <v-icon size="48" color="rgba(255,255,255,0.3)">mdi-clock-alert-outline</v-icon>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-card class="dashboard-card premium-card gradient-danger rounded-xl" elevation="4">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <div class="text-caption text-uppercase font-weight-bold white--text mb-1">Documentos
                                Vencidos</div>
                            <h2 class="text-h4 font-weight-black white--text">{{ kpis.expiredDocs }}</h2>
                        </div>
                        <v-icon size="48" color="rgba(255,255,255,0.3)">mdi-file-cancel-outline</v-icon>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="6">
                <v-card class="dashboard-card premium-card gradient-dark rounded-xl" elevation="4">
                    <div class="d-flex justify-space-between align-center">
                        <div>
                            <div class="text-caption text-uppercase font-weight-bold white--text mb-1">Infracciones
                                Activas</div>
                            <h2 class="text-h4 font-weight-black white--text">{{ kpis.activeViolations }}</h2>
                        </div>
                        <v-icon size="48" color="rgba(255,255,255,0.3)">mdi-alert-octagon</v-icon>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-row dense>
            <!-- Alertas Próximos a Vencer -->
            <v-col cols="12">
                <v-card class="rounded-xl overflow-hidden" elevation="2">
                    <div class="d-flex flex-wrap align-center justify-space-between pa-4">
                        <div class="d-flex align-center">
                            <v-avatar color="warning lighten-5" class="mr-3" size="40">
                                <v-icon color="warning">mdi-bell-ring-outline</v-icon>
                            </v-avatar>
                            <div>
                                <h3 class="title font-weight-bold mb-0">Alertas de Vencimiento</h3>
                                <span class="text-caption text--secondary">
                                    Control y seguimiento de la vigencia de la documentación
                                </span>
                            </div>
                        </div>

                    </div>

                    <!-- Tarjetas de Filtro y Resumen Elegantes -->
                    <div class="px-4 pb-4 d-flex flex-wrap" style="gap: 12px;">
                        <v-card v-for="card in filterCards" :key="card.value"
                            :class="['filter-summary-card', card.bgClass, alertStatusFilter === card.value ? card.activeClass : '']"
                            @click="alertStatusFilter = card.value"
                            elevation="1"
                            class="rounded-xl flex-grow-1 flex-shrink-0 cursor-pointer"
                            style="min-width: 170px; max-width: 280px;"
                        >
                            <v-card-text class="pa-4 d-flex flex-column justify-space-between fill-height">
                                <div class="d-flex justify-space-between align-start mb-2">
                                    <span class="card-title-text font-weight-bold text-truncate" :title="card.title">
                                        {{ card.title }}
                                    </span>
                                    <v-icon :color="alertStatusFilter === card.value ? 'white' : card.color" size="24">
                                        {{ card.icon }}
                                    </v-icon>
                                </div>
                                <div class="d-flex align-end justify-space-between mt-2">
                                    <span class="card-count-number font-weight-black">
                                        {{ card.count }}
                                    </span>
                                    <span class="card-action-text font-weight-medium text-caption" v-if="alertStatusFilter === card.value">
                                        Filtrado
                                    </span>
                                    <span class="card-action-text font-weight-medium text-caption" v-else>
                                        Filtrar
                                    </span>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>

                    <v-divider></v-divider>

                    <v-data-table :headers="alertHeaders" :items="filteredAlerts" :items-per-page="5"
                        class="elevation-0 premium-table" dense
                        no-data-text="No se encontraron alertas con los filtros seleccionados">
                        <template v-slot:item.SpcCompanyName="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-avatar size="38" color="amber lighten-5" class="mr-3 elevation-1">
                                    <v-icon color="amber darken-3" size="20">mdi-truck-cargo-container</v-icon>
                                </v-avatar>
                                <div>
                                    <div class="font-weight-bold text-subtitle-2 text-truncate"
                                        style="max-width: 280px;" :title="item.SpcCompanyName">
                                        {{ item.SpcCompanyName }}
                                    </div>
                                    <div class="caption text--secondary font-weight-medium">
                                        ID / Código: {{ item.SpcID || 'N/A' }}
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-slot:item.SpcTypeName="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-avatar size="24" color="grey lighten-4" class="mr-2">
                                    <v-icon color="grey darken-2" size="14">mdi-file-document-outline</v-icon>
                                </v-avatar>
                                <span class="font-weight-medium text-body-2">{{ item.SpcTypeName }}</span>
                            </div>
                        </template>

                        <template v-slot:item.SpcExpireDate="{ item }">
                            <div class="d-flex align-center justify-center py-2">
                                <v-chip class="font-weight-bold px-3 rounded-lg border" color="white"
                                    text-color="grey darken-3" small outlined>
                                    <v-icon left size="14" color="grey">mdi-calendar-range</v-icon>
                                    {{ formatDate(item.SpcExpireDate) }}
                                </v-chip>
                            </div>
                        </template>

                        <template v-slot:item.daysLeft="{ item }">
                            <div class="d-flex flex-column align-center py-2" style="min-width: 150px; width: 100%;">
                                <v-chip small :color="getAlertColor(item.daysLeft)"
                                    class="white--text font-weight-bold mb-1 px-3 elevation-1" style="height: 24px;">
                                    <v-icon left size="14" class="mr-1">
                                        {{ item.daysLeft < 0 ? 'mdi-alert-circle' : item.daysLeft <= 5 ? 'mdi-alert'
                                            : 'mdi-clock-outline' }} </v-icon>
                                            {{ item.daysLeft < 0 ? `Vencido (${Math.abs(item.daysLeft)}d)` :
                                                item.daysLeft === 0 ? 'Vence Hoy' : `En ${item.daysLeft} días` }}
                                                </v-chip>
                                                <div class="px-2" style="width: 100%; max-width: 140px;">
                                                    <v-progress-linear :value="getProgressBarValue(item.daysLeft)"
                                                        :color="getAlertColor(item.daysLeft)" height="4" rounded
                                                        class="mt-1"></v-progress-linear>
                                                </div>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>

            <!-- Infracciones de Conductores -->
            <v-col cols="12">
                <v-card class="rounded-xl mt-4" elevation="2">
                    <v-card-title class="subtitle-1 font-weight-bold">
                        <v-icon color="error" class="mr-2">mdi-account-alert</v-icon>
                        Infracciones de Conductores
                        <v-spacer></v-spacer>
                        <v-btn small color="primary" outlined @click="exportViolations">
                            <v-icon left>mdi-file-excel</v-icon> Exportar
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-data-table :headers="violationHeaders" :items="violations" :items-per-page="5"
                        class="elevation-0" dense>
                        <template v-slot:item.DriverName="{ item }">
                            <div class="font-weight-medium">{{ item.DriverName }}</div>
                            <div class="text-caption text--secondary">Placa: {{ item.VehPlate }}</div>
                        </template>
                        <template v-slot:item.ViolationTypeName="{ item }">
                            <v-chip x-small class="white--text px-1 rounded"
                                :color="item.ViolationLevel == 1 ? 'yellow' : (item.ViolationLevel == 2) ? 'orange' : 'red'">
                                {{ item.ViolationLevelName }}
                            </v-chip>
                            <span class="ml-2 text-caption">{{ item.ViolationTypeName }}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import _SpcCarrierService from "@/services/SupplyChain/Transport/SpcCarrierService.js";
import _SpcDocumentService from "@/services/SupplyChain/Transport/SpcDocumentService.js";
import _SpcTrafficViolationService from "@/services/SupplyChain/TrafficViolation/SpcTrafficViolationService.js";
import _sDefinition from "@/services/General/DefinitionService.js";
import dayjs from "dayjs";
import * as XLSX from "xlsx"; // Asumiendo que XLSX está disponible o se puede exportar simple

export default {
    name: "SpcCarriersDashboard",
    data: () => ({
        typeFilesLength: 1,
        providers: [],
        expiringAlerts: [],
        violations: [],
        searchAlertQuery: "",
        alertStatusFilter: "all",
        kpis: {
            completeProviders: 0,
            expiringDocs: 0,
            expiredDocs: 0,
            activeViolations: 0
        },
        providerHeaders: [
            { text: "Transportista", value: "SpcCompanyName", width: "40%" },
            { text: "Progreso", value: "progress", width: "30%", align: "center" },
            { text: "Estado", value: "status", width: "30%", align: "center" }
        ],
        alertHeaders: [
            { text: "Transportista", value: "SpcCompanyName" },
            { text: "Tipo de Documento", value: "SpcTypeName" },
            { text: "Fecha Vencimiento", value: "SpcExpireDate", align: "center" },
            { text: "Estado / Tiempo Restante", value: "daysLeft", align: "center" }
        ],
        violationHeaders: [
            { text: "Fecha", value: "ViolationDate" },
            { text: "Conductor / Placa", value: "DriverName" },
            { text: "Tipo de Infracción", value: "ViolationTypeName" },
            { text: "Monto", value: "Amount" },
            { text: "Estado", value: "StateName" }
        ]
    }),
    computed: {
        filterCards() {
            return [
                {
                    value: "all",
                    title: "Todos",
                    count: this.expiringAlerts.length,
                    icon: "mdi-file-multiple",
                    color: "grey darken-1",
                    bgClass: "card-all",
                    activeClass: "active-all"
                },
                {
                    value: "expired",
                    title: "Vencidos",
                    count: this.expiringAlerts.filter(a => a.daysLeft < 0).length,
                    icon: "mdi-alert-circle-outline",
                    color: "error",
                    bgClass: "card-expired",
                    activeClass: "active-expired"
                },
                {
                    value: "5days",
                    title: "Vencen en 5 días",
                    count: this.expiringAlerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 5).length,
                    icon: "mdi-timer-sand",
                    color: "deep-orange",
                    bgClass: "card-5days",
                    activeClass: "active-5days"
                },
                {
                    value: "15days",
                    title: "Vencen en 15 días",
                    count: this.expiringAlerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 15).length,
                    icon: "mdi-calendar-alert",
                    color: "warning darken-1",
                    bgClass: "card-15days",
                    activeClass: "active-15days"
                },
                {
                    value: "30days",
                    title: "Vencen en 30 días",
                    count: this.expiringAlerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 30).length,
                    icon: "mdi-calendar-clock",
                    color: "info",
                    bgClass: "card-30days",
                    activeClass: "active-30days"
                }
            ];
        },
        criticalAlertsCount() {
            return this.expiringAlerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 5).length;
        },
        warningAlertsCount() {
            return this.expiringAlerts.filter(a => a.daysLeft > 5 && a.daysLeft <= 30).length;
        },
        filteredAlerts() {
            let alerts = this.expiringAlerts;

            // Filtrar por estado
            if (this.alertStatusFilter === "expired") {
                alerts = alerts.filter(a => a.daysLeft < 0);
            } else if (this.alertStatusFilter === "5days") {
                alerts = alerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 5);
            } else if (this.alertStatusFilter === "15days") {
                alerts = alerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 15);
            } else if (this.alertStatusFilter === "30days") {
                alerts = alerts.filter(a => a.daysLeft >= 0 && a.daysLeft <= 30);
            }

            // Filtrar por término de búsqueda
            if (this.searchAlertQuery) {
                const query = this.searchAlertQuery.toLowerCase();
                alerts = alerts.filter(a => {
                    const company = (a.SpcCompanyName || "").toLowerCase();
                    const typeName = (a.SpcTypeName || "").toLowerCase();
                    return company.includes(query) || typeName.includes(query);
                });
            }

            return alerts;
        }
    },
    mounted() {
        this.initializeDashboard();
    },
    methods: {
        formatDate(date) {
            if (!date) return "";
            return dayjs(date).format("DD/MM/YYYY");
        },
        getProgressBarValue(daysLeft) {
            if (daysLeft <= 0) return 0;
            return Math.min(100, Math.round((daysLeft / 30) * 100));
        },
        async initializeDashboard() {
            try {
                // 1. Obtener definicion de documentos
                const defResp = await _sDefinition.definitiongroup(1596, 0, this.$fun.getUserID());
                if (defResp.status === 200 && defResp.data) {
                    this.typeFilesLength = defResp.data.length || 1;
                }

                this.loadProviders();
                this.loadDocumentsAlerts();
                this.loadViolations();
            } catch (error) {
                console.error("Error initializing dashboard", error);
            }
        },

        async loadProviders() {
            try {
                const filters = {
                    Search: '',
                    Type: null,
                };
                const resp = await _SpcCarrierService.list(filters, this.$fun.getUserID());
                if (resp.status === 200 && resp.data) {
                    this.providers = resp.data.map(item => {
                        const count = item.CountDocuments || 0;
                        const progress = Math.round((count / this.typeFilesLength) * 100);
                        return {
                            ...item,
                            progress: progress > 100 ? 100 : progress
                        };
                    });

                    // Update KPI
                    this.kpis.completeProviders = this.providers.filter(p => p.progress === 100).length;
                }
            } catch (error) {
                console.error("Error loading providers", error);
            }
        },

        async loadDocumentsAlerts() {
            // Asumiendo que podemos obtener alertas desde paginación sin filtro estricto
            // Si la API no permite esto directamente, simularemos con datos existentes.
            try {
                const params = {
                    filter: { Search: '' }, draw: 1, start: 0, length: -1,
                    order: [{ dir: "asc", column: "" }], searchText: "",
                };

                const resp = await _SpcDocumentService.pagination(params, this.$fun.getUserID());
                if (resp.status === 200 && resp.data && resp.data.data) {
                    const today = dayjs();
                    let expiring = [];
                    let expiredCount = 0;
                    let expiringCount = 0;

                    resp.data.data.forEach(doc => {
                        if (doc.SpcExpireDate) {
                            const expireDate = dayjs(doc.SpcExpireDate);
                            const daysLeft = expireDate.diff(today, 'day');

                            if (daysLeft < 0) {
                                expiredCount++;
                                expiring.push({ ...doc, daysLeft });
                            } else if (daysLeft <= 30) { // 30, 15, 5 days
                                expiringCount++;
                                expiring.push({ ...doc, daysLeft });
                            }
                        }
                    });

                    this.expiringAlerts = expiring.sort((a, b) => a.daysLeft - b.daysLeft);
                    this.kpis.expiredDocs = expiredCount;
                    this.kpis.expiringDocs = expiringCount;
                }
            } catch (error) {
                console.error("Error loading document alerts", error);
            }
        },

        async loadViolations() {
            try {
                const params = {
                    filter: { Search: '' }, draw: 1, start: 0, length: -1,
                    order: [{ dir: "asc", column: "" }], searchText: "",
                };
                // console.log(JSON.parse(JSON.stringify({ params })))
                const resp = await _SpcTrafficViolationService.pagination(params, this.$fun.getUserID());
                if (resp.status === 200 && resp.data && resp.data.data) {
                    this.violations = resp.data.data;
                    this.kpis.activeViolations = this.violations.length; // Podría filtrarse por estado activo
                }
            } catch (error) {
                console.error("Error loading violations", error);
            }
        },

        getSemaphoreColor(progress) {
            if (progress === 100) return "success";
            if (progress >= 50) return "warning";
            return "error";
        },

        getStatusText(progress) {
            if (progress === 100) return "Completo";
            if (progress > 0) return "Pendiente";
            return "Faltante";
        },

        getAlertColor(daysLeft) {
            if (daysLeft < 0) return "error";
            if (daysLeft <= 5) return "deep-orange";
            if (daysLeft <= 15) return "warning";
            if (daysLeft <= 30) return "amber darken-2";
            return "success";
        },

        exportToExcel(data, filename) {
            if (!data || data.length === 0) {
                this.$fun.alert("No hay datos para exportar", "warning");
                return;
            }
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, `${filename}.xlsx`);
        },

        exportProviders() {
            const data = this.providers.map(p => ({
                "Transportista": p.SpcCompanyName,
                "RUC": p.SpcDocument,
                "Progreso (%)": p.progress,
                "Estado": this.getStatusText(p.progress)
            }));
            this.exportToExcel(data, "Estado_Documentacion_Transportistas");
        },

        exportAlerts() {
            const data = this.expiringAlerts.map(a => ({
                "Transportista": a.SpcCompanyName || a.SpcID, // Ajustar segun API
                "Documento": a.SpcTypeName,
                "Fecha Vencimiento": a.SpcExpireDate ? dayjs(a.SpcExpireDate).format('YYYY-MM-DD') : '',
                "Días Restantes": a.daysLeft
            }));
            this.exportToExcel(data, "Alertas_Vencimiento_Documentos");
        },

        exportViolations() {
            const data = this.violations.map(v => ({
                "Fecha": v.ViolationDate ? dayjs(v.ViolationDate).format('YYYY-MM-DD') : '',
                "Conductor": v.DriverName,
                "Placa": v.VehPlate,
                "Tipo Infracción": v.ViolationTypeName,
                "Nivel": v.ViolationLevelName,
                "Monto": v.Amount,
                "Estado": v.StateName
            }));
            this.exportToExcel(data, "Infracciones_Conductores");
        }
    }
};
</script>

<style scoped>
.premium-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    padding: 20px;
}

.premium-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2) !important;
}

.gradient-success {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.gradient-warning {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.gradient-danger {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.gradient-dark {
    background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
}

.gap-2 {
    gap: 8px;
}

.premium-table ::v-deep tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.02) !important;
    transition: background-color 0.2s ease;
}

.premium-table ::v-deep thead th {
    background-color: #f8fafc !important;
    border-bottom: 2px solid #e2e8f0 !important;
    font-weight: 700 !important;
    color: #475569 !important;
}

.status-filter-group ::v-deep .v-slide-group__content {
    gap: 4px;
}

/* Nuevas clases para las tarjetas de filtro elegante */
.filter-summary-card {
    border: 1px solid #e2e8f0 !important;
    background-color: #ffffff !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.filter-summary-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;
}

.card-title-text {
    font-size: 0.825rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.card-count-number {
    font-size: 1.85rem;
    color: #1e293b;
    line-height: 1;
}

.filter-summary-card.active-all {
    background: linear-gradient(135deg, #64748b 0%, #475569 100%) !important;
    border-color: #475569 !important;
}
.filter-summary-card.active-expired {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    border-color: #dc2626 !important;
}
.filter-summary-card.active-5days {
    background: linear-gradient(135deg, #f97316 0%, #ea580c 100%) !important;
    border-color: #ea580c !important;
}
.filter-summary-card.active-15days {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
    border-color: #d97706 !important;
}
.filter-summary-card.active-30days {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
    border-color: #2563eb !important;
}

.filter-summary-card[class*="active-"] .card-title-text {
    color: rgba(255, 255, 255, 0.8) !important;
}

.filter-summary-card[class*="active-"] .card-count-number {
    color: #ffffff !important;
}

.filter-summary-card[class*="active-"] .card-action-text {
    color: rgba(255, 255, 255, 0.9) !important;
}

.filter-summary-card .card-action-text {
    color: #94a3b8;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
